export default function (controllerMain) {
    return {
        api: {
            globalRoute: `${process.env.REACT_APP_API_FUNDES_STAR}/api/v1/${controllerMain}`,
        },
    };
}

